import React from "react";
import { getRank } from "@/lib/ranks";
import { Crown, Flame } from "lucide-react";

export const RankBadge = ({ elo = 0, size = "md", showElo = true }) => {
  const r = getRank(elo);
  const sizes = {
    sm: { wrap: "px-2 py-1 text-[10px]", icon: 10, gap: "gap-1" },
    md: { wrap: "px-3 py-1.5 text-xs", icon: 12, gap: "gap-1.5" },
    lg: { wrap: "px-4 py-2 text-sm", icon: 16, gap: "gap-2" },
  };
  const s = sizes[size] || sizes.md;
  const isGod = r.name === "Chiến Thần";

  return (
    <span
      className={`inline-flex items-center ${s.gap} ${s.wrap} font-display font-semibold uppercase tracking-wider rounded-md bg-gradient-to-br ${r.bg} border ${r.border} ${r.text} ${isGod ? "animate-pulse" : ""}`}
      data-testid="rank-badge"
      style={isGod ? { boxShadow: `0 0 14px ${r.color}66` } : {}}
    >
      {isGod ? <Flame size={s.icon} /> : <Crown size={s.icon} />}
      <span>{r.name}</span>
      {showElo && <span className="opacity-70 font-normal normal-case">· {elo}</span>}
    </span>
  );
};

export default RankBadge;
